import React, {useState} from 'react';
import close from "../../../images/close.svg";
import {connect} from "react-redux";
import {CustomCheckBox} from "../../main/logbook/EditTable";
import {addIytLicenses} from "../../../redux/profile/profile-thunks";
import {useTranslation} from "react-i18next";

const AddIytLicenses = ({closeModal, isDark, iytLicenses, addIytLicenses, setIsAddedIytLicenses}) => {
  console.log(iytLicenses)
  const [selectedLicenses, setSelectedLicenses] = useState([])
  const {t} = useTranslation()
  return (
    <div style={{width: 481}} className={`modal ${isDark && 'modal__dark'}`}>
      <button onClick={closeModal} className="modal__close">
        <img src={close} alt=""/>
      </button>
      <h5 className="modal__title mr-30">{t('addIytLicenses')}</h5>
      {iytLicenses.length === 0 && <p style={{marginBottom: 27}} className="modal__text">{t('notFoundIYT')}</p>}
      {iytLicenses.length !== 0 && <>
        <CustomCheckBox isDark={isDark} caption={t('selectAll')} onClick={() => {
          if (selectedLicenses.length === iytLicenses.length) {
            setSelectedLicenses([])
          } else {
            setSelectedLicenses(iytLicenses)
          }
        }} isChecked={selectedLicenses.length === iytLicenses.length} fontFamily={'Lato500'} color={'#252526'}/>
        {iytLicenses.map((lic, index) => (
          <CustomCheckBox isDark={isDark} caption={lic.license_type.name} key={index} onClick={() => {
            if (selectedLicenses.find(l => l.license_number === lic.license_number) !== undefined) setSelectedLicenses([...selectedLicenses].filter(s => s.license_number !== lic.license_number))
            else setSelectedLicenses([...selectedLicenses, lic])
          }} isChecked={selectedLicenses.find(l => l.license_number === lic.license_number) !== undefined}
                          fontFamily={'Lato500'} color={'#252526'}/>
        ))}
      </>}
      <div className="modal__buttons">
        <div className="modal__actions">
          <button onClick={() => {
            if (iytLicenses.length !== 0) {
              addIytLicenses(selectedLicenses)
              setIsAddedIytLicenses(true)
            }
            closeModal()
          }} disabled={selectedLicenses.length === 0 && iytLicenses.length !== 0}
                  className={`submit-button ${(selectedLicenses.length === 0 && iytLicenses.length !== 0) && 'submit-button__disabled'}`}>
            {iytLicenses.length === 0 ? 'Ok' : t('add')}
          </button>
          <button className={`commonBtn ${isDark && 'commonBtn__dark'}`}>
            <span className="commonBtn__label">{t('cancel')}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  iytLicenses: state.profileReducer.iytLicenses
})

export default connect(mapStateToProps, {addIytLicenses})(AddIytLicenses)
